import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useOnClickOutside } from "../../customHooks/useOnClickOutside";
import { userLogoutAction } from "../../redux/actions";
import { serviceAuthentication } from "../../services/AuthenticationService";
import React from "react";

// styles
require("./UserInfo.css");

export const UserInfo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [expanded, setExpanded] = useState(false);

  const ref = useRef(null);

  useOnClickOutside(ref, () => setExpanded(false));

  const userInfo = useSelector((state: any) => state.userInfo);

  const onSignOutClick = () => {
    serviceAuthentication.logout().then((responseData) => {
      setExpanded(false);
      localStorage.removeItem("currentUser");
      serviceAuthentication.currentUserSubject.next(null);
      dispatch(userLogoutAction(JSON.stringify(responseData.data)));
    });
  };

  const onLoginClick = () => {
    history.push("/login");
  };

  const onChangePasswordClick = () => {};

  return (
    <div ref={ref}>
      <div style={{ display: "flex" }}>
        <a
          className="nav-link Ripple-parent"
          rel="noopener noreferrer"
          href="https://mdbootstrap.com/product/react-bootstrap-pro/"
          target="_blank"
        >
          <i className="fa fa-github mr-2"></i>
          <i className="far fa-user"></i>
        </a>

        {userInfo.Anonymous && (
          <input
            type="button"
            value="Přihlásit"
            className="btn btn-primary btn-sm"
            onClick={onLoginClick}
          />
        )}
        {!userInfo.Anonymous && (
          <a
            className="dropdown-toggle d-flex align-items-center hidden-arrow"
            href="#"
            id="navbarDropdownMenuLink"
            role="button"
            data-mdb-toggle="dropdown"
            aria-expanded={expanded}
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            <div>
              {userInfo.Username} ({userInfo.DisplayName})
            </div>
          </a>
        )}
      </div>
      {expanded && (
        <ul
          className="dropdown-menu"
          style={{ display: "block", left: "unset", right: "20px" }}
          aria-labelledby="navbarDropdownMenuLink"
        >
          <li>
            <a className="dropdown-item" href="#">
              Změna hesla
            </a>
          </li>
          <li>
            <a onClick={onSignOutClick} className="dropdown-item" href="#">
              Odhlášení
            </a>
          </li>
        </ul>
      )}
    </div>
  );
};
